import {
    getFirestore,
    collection,
    getDocs,
    updateDoc,
    doc,
    getDoc,
    Timestamp,
    deleteDoc,
    addDoc,
} from "firebase/firestore";
import { ErrorHelper } from "../helpers/ErrorHelper";
import { FireHelper } from "../helpers/FireHelper";
import { Firebase } from "../FirebaseApp";
import { toast } from "react-toastify";
import { getFunctions, httpsCallable } from "firebase/functions";

export const FeeController = {
    db: getFirestore(Firebase),
    functions: getFunctions(Firebase),

    ToFirestoreBoatType: function (data) {
        let updatedData = {
            id: data.id,
            name: data.name,
            price: data.price,
            description: data.description,
            billing_cycle: data.billing_cycle,
            created_at: data.created_at ?? Timestamp.now(),
            updated_at: Timestamp.now(),
        };
        return FireHelper.ToFirestoreDoc(updatedData);
    },

    Insert: async function (data, res) {
      try {
            const createStripePlan = httpsCallable(this.functions, "createStripePlan");
            const response = await createStripePlan({...data});
            console.log("Token claims updated successfully:", response.data);
            res(response.data);
          } catch (error) {
            console.error("Error updating token claims:", error.message);
          toast(ErrorHelper.HandleMessage(error));
          }
      },

    Update: async function (data, res) {
         try {
            const updateStripePlan = httpsCallable(this.functions, "updateStripePlan");
            const response = await updateStripePlan({...data});
            console.log("Token claims updated successfully:", response.data);
            res(response.data);
          } catch (error) {
            console.error("Error updating token claims:", error.message);
          toast(ErrorHelper.HandleMessage(error));
          }
    },

    List: async function (res) {
        const querySnapshot = await getDocs(
            collection(this.db, "plans")
        );
        const results = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
        }));
        res(results);
    },

    ListActivePlans: async function (res) {
        const querySnapshot = await getDocs(
            collection(this.db, "plans")
        );
        const results = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
        })).filter(plan => plan.active === true);
        res(results);
    },

    GetPlanPrices: async function (planId, res) {
        try {
            const querySnapshot = await getDocs(
                collection(this.db, "plans", planId, "plan_prices")
            );

            const results = querySnapshot.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
            })).filter(price => price.active === true);

            console.log("Plan prices retrieved successfully:", results);
            res(results);
        } catch (error) {
            console.error("Error retrieving plan prices:", error.message);
            toast(ErrorHelper.HandleMessage(error));
            res([]);
        }
    },
    
  Delete: async function (id) {
     try {
            const deleteStripePlan = httpsCallable(this.functions, "deleteStripePlan");
            const response = await deleteStripePlan({"planId": id});
            console.log("Token claims updated successfully:", response.data);
          } catch (error) {
            console.error("Error updating token claims:", error.message);
          toast(ErrorHelper.HandleMessage(error));
          }
  },
};
